import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import './HomePage.css';

function HomePage() {
  const { user } = useAuth();
  const [backgrounds, setBackgrounds] = useState([]);
  const [currentBgIndex, setCurrentBgIndex] = useState(0);

  // Fetch background images on mount
  useEffect(() => {
    const fetchBackgrounds = async () => {
      try {
        const response = await axios.get('/api/backgrounds');
        if (response.data.backgrounds && response.data.backgrounds.length > 0) {
          setBackgrounds(response.data.backgrounds);
        }
      } catch (error) {
        console.error('Error fetching backgrounds:', error);
      }
    };
    fetchBackgrounds();
  }, []);

  // Auto-rotate backgrounds every 10 seconds
  useEffect(() => {
    if (backgrounds.length === 0) return;

    const interval = setInterval(() => {
      setCurrentBgIndex((prev) => (prev + 1) % backgrounds.length);
    }, 10000); // Change every 10 seconds

    return () => clearInterval(interval);
  }, [backgrounds]);

  // Get current background image URL
  const currentBackgroundUrl = backgrounds.length > 0
    ? `/api/backgrounds/${backgrounds[currentBgIndex]}`
    : null;

  return (
    <div className="home-page">
      <div
        className="hero"
        style={currentBackgroundUrl ? {
          backgroundImage: `linear-gradient(rgba(102, 126, 234, 0.7), rgba(118, 75, 162, 0.7)), url(${currentBackgroundUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        } : {}}
      >
        {!user && (
          <Link to="/login" className="login-register-btn">
            Login/Register
          </Link>
        )}

        <h1>Salt Delivery Service</h1>
        <p>Get snow-melting salt and water softener salt delivered to your door</p>

        {!user && (
          <div className="hero-buttons">
            <Link to="/register" className="btn btn-primary">
              Get your salt
            </Link>
            <Link to="/register-driver" className="btn btn-secondary">
              Sign up to drive
            </Link>
          </div>
        )}
      </div>

      <div className="features">
        <div className="feature-card">
          <h3>Easy Ordering</h3>
          <p>Order via email, QR code, or our simple web interface</p>
        </div>

        <div className="feature-card">
          <h3>Delivery Tracking</h3>
          <p>Get notified via email and SMS about your delivery status</p>
        </div>
      </div>

      <div className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Choose Your Salt</h3>
            <p>Select from snow-melting or water softener salt products</p>
          </div>

          <div className="step">
            <div className="step-number">2</div>
            <h3>Schedule Delivery</h3>
            <p>One-time order or set up a monthly subscription</p>
          </div>

          <div className="step">
            <div className="step-number">3</div>
            <h3>Receive & Confirm</h3>
            <p>Get your delivery with photo confirmation</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
